import { createFileRoute } from "@tanstack/react-router";

import { BillingPage } from "@/features/billing";
import {
  requireSubscriptionManagement,
  requireSubscriptionOwner,
} from "@/lib/subscription-management";

export const Route = createFileRoute("/_auth/_app-shell/billing/$projectId")({
  beforeLoad: async ({ context }) => {
    requireSubscriptionOwner(context.queryClient);
    await requireSubscriptionManagement();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return <BillingPage projectId={projectId} />;
}
